import React, {Fragment, useState} from "react";
//import Multistep from "react-multistep";
import {Stepper, Step} from "react-form-stepper";

import FormAjoutAnnonce from "./Form";
import SelectCategory from "./selectCategory";
import SelectSubCategory from "./selectSubCategory";
import SelectSector from "./selectSector";

const AnnonceStepper = () => {
  const [goSteps, setGoSteps] = useState(0);
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [selectedSubCategory, setSelectedSubCategory] = useState([]);
  const [selectedSector, setSelectedSector] = useState(null);

  return (
    <Fragment>
      <div className="row">
        <div className="col-xl-12">
          <div className="card">
            <div className="card-header">
              <h4 className="font-bold text-[20px] text-[#19295C] ">
                Ajout d'annonce
              </h4>
            </div>
            <div className="card-body">
              <div className="form-wizard ">
                <Stepper
                  className="nav-wizard !mx-auto md:!px-32 !py-5"
                  activeStep={goSteps}
                  label={false}
                >
                  <Step className="nav-link" onClick={() => setGoSteps(0)} />
                  <Step className="nav-link" onClick={() => setGoSteps(1)} />
                  <Step className="nav-link" onClick={() => setGoSteps(2)} />
                  {/* <Step className="nav-link" onClick={() => setGoSteps(3)} /> */}
                </Stepper>
                {goSteps === 0 && (
                  <>
                    <SelectSector
                      selectedSector={selectedSector}
                      setSelectedSector={setSelectedSector}
                    >
                      <div className="text-center  sm:!text-right toolbar toolbar-bottom  ">
                        <button
                          className="btn min-w-[200px] sm:!min-w-[250px]  !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white sw-btn-next"
                          onClick={() => setGoSteps(1)}
                          disabled={!selectedSector}
                        >
                          Suivant
                        </button>
                      </div>
                    </SelectSector>
                  </>
                )}
                {goSteps === 1 && (
                  <>
                    <SelectCategory
                      selectedSector={selectedSector}
                      selectedCategory={selectedCategory}
                      setSelectedCategory={setSelectedCategory}
                      selectedSubCategory={selectedSubCategory}
                      setSelectedSubCategory={setSelectedSubCategory}
                    >
                      <div className="w-full flex-col justify-center sm:flex-row sm:justify-end flex gap-2  ">
                        <button
                          className="btn min-w-[200px] sm:!min-w-[250px]  !rounded-lg bg-white !text-[#0D44B1] !border-[#0D44B1] !border  border-solid "
                          onClick={() => setGoSteps(0)}
                        >
                          Retour
                        </button>
                        <button
                          className="btn min-w-[200px] sm:!min-w-[250px]   !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white sw-btn-next"
                          onClick={() => setGoSteps(2)}
                          disabled={!selectedSubCategory.length}
                        >
                          Suivant
                        </button>
                      </div>
                    </SelectCategory>
                    {/* <SelectSubCategory
                      selectedCategory={selectedCategory}
                      selectedSubCategory={selectedSubCategory}
                      setSelectedSubCategory={setSelectedSubCategory}
                    >
                      <div className="w-full flex-col justify-center sm:flex-row sm:justify-end flex gap-2  ">
                        <button
                          className="btn !min-w-[250px]  !rounded-lg bg-white !text-[#0D44B1] !border-[#0D44B1] !border  border-solid "
                          onClick={() => setGoSteps(1)}
                        >
                          Retour
                        </button>
                        <button
                          className="btn !min-w-[250px]  !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white sw-btn-next"
                          onClick={() => setGoSteps(3)}
                          disabled={!selectedSubCategory?.length}
                        >
                          Suivant
                        </button>
                      </div>
                    </SelectSubCategory> */}
                  </>
                )}
                {/* {goSteps === 2 && (
                  <>
                    <SelectSubCategory
                      selectedCategory={selectedCategory}
                      selectedSubCategory={selectedSubCategory}
                      setSelectedSubCategory={setSelectedSubCategory}
                    >
                      <div className="w-full flex-col justify-center sm:flex-row sm:justify-end flex gap-2  ">
                        <button
                          className="btn !min-w-[250px]  !rounded-lg bg-white !text-[#0D44B1] !border-[#0D44B1] !border  border-solid "
                          onClick={() => setGoSteps(1)}
                        >
                          Retour
                        </button>
                        <button
                          className="btn !min-w-[250px]  !rounded-lg bg-gradient-to-r from-[#0022AA] to-[#1A64B9] text-white sw-btn-next"
                          onClick={() => setGoSteps(3)}
                          disabled={!selectedSubCategory?.length}
                        >
                          Suivant
                        </button>
                      </div>
                    </SelectSubCategory>
                  </>
                )} */}

                {goSteps === 2 && (
                  <>
                    <FormAjoutAnnonce
                      selectedSubCategory={selectedSubCategory}
                      setGoSteps={setGoSteps}
                    />
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </Fragment>
  );
};

export default AnnonceStepper;
